module.exports = __webpack_public_path__ + "static/media/GNIT_Kolkata_logo.ab5719af.png";